var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"HomePageMainBox"},[_c('div',{staticClass:"HomeChartBox"},[_c('div',{staticClass:"HomeChartLeft"},[_c('div',{staticClass:"HomePageBox",attrs:{"id":"HomeChartLeftMain"}})]),_c('div',{staticClass:"HomeChartRight"},[_c('div',{staticClass:"HomePageBox",attrs:{"id":"HomeChartRightMain"}})])])])
}]

export { render, staticRenderFns }